import styled from 'styled-components';

export const Toolbar = styled.div`
  .btn {
    font-size: 14px;
  }

  .btn .material-icons {
    font-size: 20px;
  }
`;
